// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1iupZ","inputWrap":"Table_inputWrap__3ngcz","col":"Table_col__1TXnH","bmiTooltip":"Table_bmiTooltip__3oKz6"};